import { render } from "./Span.vue?vue&type=template&id=178e3106&scoped=true"
import script from "./Span.vue?vue&type=script&lang=ts"
export * from "./Span.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-178e3106"

export default script